import { render, staticRenderFns } from "./ServiceAttributesCard.vue?vue&type=template&id=04917406&scoped=true&"
import script from "./ServiceAttributesCard.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ServiceAttributesCard.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./ServiceAttributesCard.vue?vue&type=style&index=0&id=04917406&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04917406",
  null
  
)

export default component.exports